var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 8.9002L4.6 8.5002L3.8 9.10019L4.1 9.5002L4.9 8.9002ZM10.9 9.5002L11.2 9.10019L10.4 8.5002L10.1 8.9002L10.9 9.5002ZM7.5 14.2002C3.91015 14.2002 1 11.29 1 7.7002H0C0 11.8423 3.35786 15.2002 7.5 15.2002V14.2002ZM14 7.7002C14 11.29 11.0899 14.2002 7.5 14.2002V15.2002C11.6421 15.2002 15 11.8423 15 7.7002H14ZM7.5 1.2002C11.0899 1.2002 14 4.11034 14 7.7002H15C15 3.55806 11.6421 0.200195 7.5 0.200195V1.2002ZM7.5 0.200195C3.35786 0.200195 0 3.55806 0 7.7002H1C1 4.11034 3.91015 1.2002 7.5 1.2002V0.200195ZM4 6.2002H5V5.2002H4V6.2002ZM10 6.2002H11V5.2002H10V6.2002ZM10.1 8.9002C8.8 10.6335 6.2 10.6335 4.9 8.9002L4.1 9.5002C5.8 11.7669 9.2 11.7669 10.9 9.5002L10.1 8.9002Z",
    fill: "#13100D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileBlack);
export default __webpack_public_path__ + "static/media/smile-black.7692b10471379e6024ae4a160fd0a360.svg";
export { ForwardRef as ReactComponent };